import { Mock } from "../lib/appfuse-react/core/ajax";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import inboxService from "../mock/inbox/inboxService";
import registrationService from "../mock/registration/registrationService";
import applicationTitleService from "../mock/applicationTitle/applicationTitleService";
import workflowService from "../mock/workflow/workflowService";
import applicationService from "../mock/application/applicationService";
import surveyService from "../mock/survey";
import settingService from "../mock/setting/settingService";
import inspectorService from "../mock/inspector/inspectorService";
import assessmentDataService from "../mock/assessmentData/assessmentDataService";
import regularPlanService from "../mock/regularPlan/regularPlanService";
import assessmentReviewMeetingService from "../mock/assessmentReviewMeeting/assessmentReviewMeetingService";
import irregularApplicationService from "../mock/irregularApplication/irregularApplicationService";
import marketTestInboxService from "../mock/marketTestInbox/marketTestInboxService";
import marketTestService from "../mock/marketTest/marketTestService";
import applicationManagementService from "../mock/applicationManagement/applicationManagementService";
import applicationProcessingService from "../mock/applicationProcessing/applicationProcessingService";
import overdueApplicationInboxService from "../mock/overdueApplicationInbox/overdueApplicationInboxService";
import customerManagementService from "../mock/customerManagement/customerManagementService";
import kpiService from "../mock/kpi/kpiService";
import testListService from "../mock/testList/testListService";
import workflowRoleSettingService from "../mock/workflowRoleSetting/workflowRoleSettingService";
import leezenApplicationManagementService from "../mock/leezenApplicationManagement/leezenApplicationManagementService";
import accountStatementService from "../mock/accountStatement/accountStatementService";


const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService);
    mock.use(inboxService);
    mock.use(registrationService);
    mock.use(applicationTitleService);
    mock.use(workflowService);
    mock.use(applicationService);
    mock.use(surveyService);
    mock.use(settingService);
    mock.use(inspectorService);
    mock.use(assessmentDataService);
    mock.use(regularPlanService);
    mock.use(assessmentReviewMeetingService);
    mock.use(marketTestInboxService);
    mock.use(irregularApplicationService);
    mock.use(marketTestService);
    mock.use(applicationManagementService);
    mock.use(applicationProcessingService);
    mock.use(overdueApplicationInboxService);
    mock.use(customerManagementService);
    mock.use(kpiService);
    mock.use(testListService);
    mock.use(workflowRoleSettingService);
    mock.use(leezenApplicationManagementService);
    mock.use(accountStatementService);

    return mock;
}());

const context = {mock};

export default context;

export {mock};